import { Spin } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const FullPageSpinner = (): ReactNode => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Spin size="large" tip={t('common.labels.loading')} />
    </div>
  )
}
